module.exports = " <img :src=src :data-zoom=_srcZoom /> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Common/ZoomImage.vue
// module id = 643
// module chunks = 0